import { Button, Box, IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import usePermission from '../../hooks/usePermission';
import MainContainer from '../../layout/MainContainer';

const RegisteredUsers = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const { isAdd, isDelete } = usePermission({
    label: 'Registrations',
    page_permission: 'isView',
  });

  const rows = [
    {
      id: 1,
      date: '12 Jan 2024',
      gender: 'Female',
      mobile: '(555) 123-4567',
      country: 'Saudi Arab',
      socialMedia: 'Social',
    },
    {
      id: 2,
      date: '12 Jan 2024',
      gender: 'Female',
      mobile: '(555) 123-4567',
      country: 'Saudi Arab',
      socialMedia: 'Social',
    },
    {
      id: 3,
      date: '12 Jan 2024',
      gender: 'Female',
      mobile: '(555) 123-4567',
      country: 'Saudi Arab',
      socialMedia: 'Social',
    },
    {
      id: 4,
      date: '12 Jan 2024',
      gender: 'Female',
      mobile: '(555) 123-4567',
      country: 'Saudi Arab',
      socialMedia: 'Social',
    },
  ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 125,
      field: 'membershipId',
      headerName: 'Membership #',
      editable: false,
      sortable: false,
      renderCell: () => {
        return <p className="c_black">CR12xxxxxxx</p>;
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: 'name',
      headerName: 'Name',
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <figure>
              <img src="/static/images/user_attachment.jpg" alt="" />
            </figure>
            <p>
              <b>Emma Smith</b> samith@gmail.com
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      field: 'date',
      headerName: 'Date',
      editable: false,
    },
    {
      flex: 1,
      field: 'gender',
      headerName: 'Gender',
      editable: false,
    },
    {
      flex: 1,
      minWidth: 130,
      field: 'mobile',
      headerName: 'Mobile',
      editable: false,
    },
    {
      flex: 1,
      field: 'country',
      headerName: 'Country',
      editable: false,
    },
    {
      flex: 1,
      minWidth: 130,
      field: 'orderSubmited',
      headerName: 'Order submited',
      editable: false,
      renderCell: () => {
        return <p className="c_primary">Yes</p>;
      },
    },
    {
      flex: 1,
      minWidth: 140,
      field: 'socialMedia',
      headerName: 'Social Media',
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton className="round_btn">
                <img src="/static/images/facebook_icon.svg" alt="Icon" />
              </IconButton>
            </Box>
            <Box>
              <IconButton className="round_btn">
                <img src="/static/images/instagram_icon.svg" alt="Icon" />
              </IconButton>
            </Box>
            <Box>
              <IconButton className="round_btn">
                <img src="/static/images/twitter_icon.svg" alt="Icon" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  const hidden = ['fullName'];

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Registered users</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Registered users
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Users"
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_highlight">
              <img src="/static/images/broadcast_icon.svg" alt="Icon" /> Broadcast Message
            </Button>
            <Button className="btn btn_highlight">
              <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
            </Button>
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            columns={columns?.filter((item) => !hidden.includes(item.field))}
            rows={rows}
          />
        </div>
      </div>
    </MainContainer>
  );
};

export default RegisteredUsers;
